import {useNavigate, useSearchParams} from "react-router-dom";
import {meterSelector, useGetMeterQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {EntityProfilePage} from "../EntityProfilePage/EntityProfilePage";
import {MeterProfile} from "../../components/profile/MeterProfile/MeterProfile";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";

type Props = {
  id?: string;
}

export const MeterProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const {t} = useTranslation()

  const id = params.get("id") ?? undefined;

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage
        message={t("common.entity.meter", "Meter") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return <MeterProfilePage id={id}/>;
};

export const MeterProfilePage = (props: Props) => {
  const {id} = props;

  const [access, setAccess] = useState(false);

  const selectMeter = useMemo(() => {
    return meterSelector()
  }, []);

  const {meter, isFetching, error} = useGetMeterQuery(access ? (id ?? skipToken) : skipToken, {
    selectFromResult: (result) => ({
      meter: selectMeter(result),
      isFetching: result.isFetching,
      error: result.error,
    })
  });

  return (
    <EntityProfilePage
      permissions={["meter_view"]}
      entity={meter}
      isLoading={isFetching}
      error={error}
      onAccess={setAccess}>
      {(entity) => (
        <MeterProfile meter={entity}/>
      )}
    </EntityProfilePage>
  )
};
